// @flow
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import SourcesList from './index';
import { getSourcesData } from '../../selectors';

export function mapStateToProps(state: Object) {
  const sourcesList = getSourcesData(state);
  return {
    sources: sourcesList,
    isEmpty: isEmpty(sourcesList),
  };
}

const Container = connect(mapStateToProps)(SourcesList);

export default Container;



// WEBPACK FOOTER //
// ./app/Sources/list/components/SourcesList/container.js